module.exports = __webpack_public_path__ + "media/kaczka_end_1.1d86f0f6.mp3";